import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';

import MustheadNaked from '@app/components/UI/MustHead/MustheadNaked';
import SidebarWithCaptions from '@app/components/UI/SidebarWithCaptions/SidebarWithCaptions';
import ModalVideo from '@app/components/UI/ModalVideo/ModalVideo';
import MobileMenuSlideInMenu from '@app/components/UI/MobileSlideInMenu/MobileSlideInMenu';

import '@app/scss/components/blog.scss';
import {rest} from '@app/components/Api';
import {ContentEntity, ContentTopic, ContentTopicList, ContentType} from '@app/objects/ContentTopic';
import {ContentCategory} from '@app/objects/ContentCategory';
import {ContentCategories} from '@app/objects/ContentCategories';
import RichText from '@app/components/UI/RichText/RichText';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

const ICON_LINK = [
	require('@app/images/arrow_circle.svg'),
	require('@app/images/text-button_link.svg'),
	require('@app/images/arrow_circle.svg'),
];
const TEXT_LINK = [
	'Read more',
	'Visit the site',
	'Watch Now'
];

const News = (props) => {
	// меню -- категории в блоге
	const [categoriesBlog, setCategoriesBlog] = React.useState<ContentCategory[]>();
	// меню -- выбранная категория в блоге
	const [currentCategoryBlog, setCurrentCategoryBlog] = React.useState<ContentTopic>();
	// статьи
	const [contentTopicList, setContentTopic] = React.useState<ContentEntity[]>();

	const [navCollapse, setNavCollapse] = React.useState(false);
	const [modalVisible, setModalVisible] = React.useState(false);
	const [videoSrc, setVideoSrc] = React.useState('');
	const [offsetContent, setOffsetContent] = React.useState<number>(0);
	const initArticleCount = 10;
	const [articleCount, setArticleCount] = React.useState<number>(initArticleCount);
	const [totalArticleCount, setArticleTotalCount] = React.useState<number>(0);
	const [isMobile, setIsMobile] = React.useState(false);

	const [searchFieldValue, setSearchFieldValue] = React.useState('');
	const [searchQuery, setSearchQuery] = React.useState('');
	const [isLoaded, setIsLoaded] = React.useState<boolean>(false);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);
	const content = <>
		<p>We love sharing our passion for veterinary hospice and in-home euthanasia, and our team would love to share their experience with you.
			Whether you are interested in euthanasia protocols, grief management, or hospice care tips,
			our Lap of Love veterinarians are available to speak at your veterinary hospital, club, organization, or meeting.
			Simply contact a Lap of Love veterinarian in your area to set up a speaking engagement.
		</p>
		<p>
			Lap of Love co-founders Drs. Mary Gardner and Dani McVety have presented across the country on a variety of topics related to geriatric
			care and euthanasia, and are also available to speak. As a speaker, author, consultant, and host for PetCare TV, Dr. Dani McVety enjoys
			empowering pet owners and veterinarians to seek the highest standards of pet care. Dr. Mary Gardner has presented at a number of major
			veterinary conferences, including the American Veterinary Medical Association (AVMA) Convention, North American Veterinary Conference (NAVC),
			Western Veterinary Conference (WVC), and International Association for Animal Hospice and Palliative Care (IAAHPC) Annual Conference,
			as well as numerous state and regional conferences and meetings. Both veterinarians are accomplished authors, speakers,
			and businesswomen who can tailor their presentations for professional and lay audiences.
			Please visit <a href="https://www.drdanimcvety.com/" target="_blank">Dr. McVety’s </a>
			and <a href="https://www.drmarygardner.com/" target="_blank">Dr. Gardner’s </a> personal web pages
			for more information about their upcoming speaking engagements.
		</p>
	</>;

	// меню -- категории в блоге
	React.useEffect(() => {
		rest.get<ContentCategories>('v2/contentTopics/news')
			.then((res) => {
				setCategoriesBlog(res.list);
			});
	}, []);

	// меню -- выбранная категория в блоге
	const onSetCategory = (category) => {
		setCurrentCategoryBlog(category);
		setOffsetContent(0);
		setArticleCount(initArticleCount);
	};

	// статьи
	React.useEffect(() => {
		let url;

		if (!currentCategoryBlog) {
			if (props.match.params.id) {
				if (categoriesBlog) {
					categoriesBlog.forEach((item) => {
						if (item.url === props.match.params.id) {
							onSetCategory(item);
							return false;
						}
					});
				}
				url = `v2/contentTopics/news/${props.match.params.id}/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : '' }`;
			} else {
				url = `v2/contentTopics/news/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : '' }`;
			}
		} else {
			url = `v2/contentTopics/news/${currentCategoryBlog?.url}/content?text=${searchQuery || ''}${offsetContent ? `&offset=${offsetContent}` : '' }`;
		}
		rest.get<ContentTopicList>(url)
			.then((res) => {
				offsetContent ?
					setContentTopic(prev => prev ? [...prev, ...res.list] : res.list)
					:
					setContentTopic(res.list);
				setIsLoaded(true);
				setArticleTotalCount(res.count ? res.count : 0);
			});
	}, [currentCategoryBlog, offsetContent, categoriesBlog, searchQuery]);
	
	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
	}, []);
	
	const increaseOffsetContent = (count) => {
		setOffsetContent(offsetContent + count);
	};

	const onSearchSubmit = (value) => {
		setSearchQuery(value);
		setSearchFieldValue(value);
	};

	return  (
		<div className="blog-page">
			<MustheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title={`${currentCategoryBlog ? currentCategoryBlog.name : ''}`}/>
			<div className="blog-page-body">
				<MobileMenuSlideInMenu
					topics={categoriesBlog}
					onSetIssue={onSetCategory}
					typePage={'NEWS_PAGE'}
					onSubmit={onSearchSubmit}
					searchFieldValue={searchFieldValue}
					setSearchFieldValue={setSearchFieldValue}
				/>
				<div className="blog-page__sidebar">
					<SidebarWithCaptions
						onSetIssue={onSetCategory}
						navCollapse={navCollapse}
						topics={categoriesBlog}
						withSubmit={false}
						searchFieldName={'searchFieldName'}
						searchFieldPlaceHolder={'Search by topic'}
						typeTopicsInner={'News'}
						typePage={'NEWS_PAGE'}
						searchFieldValue={searchFieldValue}
						setSearchFieldValue={setSearchFieldValue}
						onSubmit={onSearchSubmit}

					/>
				</div>

				<div className="blog-page__content">
					{currentCategoryBlog && currentCategoryBlog.name === 'Speaking Engagements' &&
						<div className="blog-page__content--empty-text">
							<RichText text={content}/>
						</div>
					}
					{currentCategoryBlog &&
						<Helmet>
							<title>{`${currentCategoryBlog.name} | In The News | Lap of Love`}</title>
							<meta name="description" property="og:description" content={currentCategoryBlog.description || undefined}/>
						</Helmet>
					}
					{!isLoaded ? <div className="faq-block__dummy">Woof! Looks like we're still loading a few things.</div> :
						contentTopicList && contentTopicList.length ? 
							contentTopicList.map((item, index) => (
							<article key={index} className="article">
								<div className="article__info">
									{isMobile && <p className="article__name-date mobile">
										{item.source && <>
											{item.source},&nbsp;
										</>}
										{new Intl.DateTimeFormat('en-US', {
											year: 'numeric',
											month: 'long',
											day: '2-digit',
											timeZone: 'UTC'
										}).format(item.date)}
									</p>
									}
									<h6 className="article__caption">{item.title}</h6>
									<p className="article__text">{item.smallText}</p>
									<div className="article__addition">
										{item.contentType === ContentType.Video ?
											<span onClick={() => {
												setModalVisible(true);
												setVideoSrc(item.url);
											}} className="article__more btn-text">
													{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
												</span> :
											(item.contentType === ContentType.Article ?
													<Link
														to={item.url}
														className="article__more btn-text"
														target={'self'}
													>
														{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
													</Link> :
													<a href={item.url} className="article__more btn-text" target={'_blank'}>
														{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
													</a>
											)
										}
	
										{!isMobile &&
											<span className="article__name-date">
												{item.source && <>
													{item.source},&nbsp;
												</>}
												{item.date > 0 && new Intl.DateTimeFormat('en-US', {
													year: 'numeric',
													month: 'long',
													day: '2-digit',
													timeZone: 'UTC'
												}).format(item.date)}
											</span>
										}
									</div>
								</div>
								<div className="article__photo" style={{backgroundImage:  `url(${item.avatar})`}}/>
							</article>
						)) : <div className="faq-block__dummy">No issues found</div>
					}

					{contentTopicList && totalArticleCount > articleCount &&
					<div className="text-center">
						<button className="btn btn-lg btn-secondary blog-page__load-more" onClick={() => {
							setOffsetContent(offsetContent + 10);
							setArticleCount(articleCount + 10);
						}}>
							Load more
						</button>
					</div>
					}
				</div>

				<ModalVideo
					modalVisible={modalVisible}
					setModalVisible={setModalVisible}
					videoSrc={videoSrc}
				/>
			</div>
		</div>
	);
};

export default News;